import { DefineGetters } from "vuex-type-helper";
import { IQuote, QuoteGetters, QuoteState } from "./types";

export const getters: DefineGetters<QuoteGetters, QuoteState> = {
  getTotalRecords: ({ links, quotes }: QuoteState) =>
    links && links.totalRecords ? links.totalRecords : quotes.length,
  getQuoteById: (state: QuoteState) => (quoteId: string) =>
    state.quotes.find((quote: IQuote) => quote._id === quoteId)
};
